import { Box, Text, useBreakpoint } from '@factorialco/deprecated-design-system'
import { F0AvatarAlert, F0Button } from '@factorialco/f0-react'
import { Phone } from '@factorialco/f0-react/icons/app'
import { AvailableModules } from 'generated/featureDefinitions'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import LeftSection from 'modules/upsell/components/SelfUpsell/OneTimeChargeModal/LeftSection'
import type Plan from 'modules/upsell/lib/selfUpsell/plans/Plan'
import { useSelfUpsellContext } from 'modules/upsell/store/SelfUpsellProvider'

type ErrorBoxProps = {
  handleAssistance: () => void
}

const ErrorBox = ({ handleAssistance }: ErrorBoxProps) => {
  return (
    <Box
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey300',
        },
      }}
      borderRadius={{ all: 'abs016' }}
      background="grey100"
      padding="s8"
      gap="s4"
      style={{
        flex: '1',
      }}
    >
      <Box
        alignItems="center"
        borderRadius={{ all: 'abs012' }}
        background="grey000White"
        boxShadow="s50"
        padding="s20"
        gap="s16"
      >
        <F0AvatarAlert type="critical" size="lg" />
        <Box textAlign="center" gap="s6">
          <Text.Normal size="200" weight="semibold" color="grey1000">
            {i18n.t('self_upsell.error_step.title')}
          </Text.Normal>
          <Text.Normal size="200" color="grey700">
            {i18n.t('self_upsell.error_step.description')}
          </Text.Normal>
        </Box>
        <Box paddingTop="s12">
          <F0Button
            icon={Phone}
            label={i18n.t('self_upsell.common.request_assistance')}
            variant="neutral"
            onClick={handleAssistance}
          />
        </Box>
      </Box>
    </Box>
  )
}

type ErrorStepProps = {
  addon: Plan
  step: string
  onClose: () => void
  handleAssistance: () => void
  moduleName: AvailableModules
}

const ErrorStep = ({ addon, step, onClose, handleAssistance, moduleName }: ErrorStepProps) => {
  const { configPlan } = useSelfUpsellContext()
  const { isMobile } = useBreakpoint()

  useEffect(() => {
    track(trackingEvents.upsell.viewSelfUpsellErrorStep, {
      module: moduleName,
      component: 'self_upsell_one_time_charge_modal',
    })
  }, [moduleName])

  return (
    <Box flexDirection="row" height="full">
      {!isMobile && (
        <LeftSection addon={addon} variant={configPlan.variant} step={step} iconName={moduleName} />
      )}
      <Box
        padding="s24"
        justifyContent="spaceBetween"
        style={{
          width: isMobile ? '100%' : '60%',
        }}
      >
        <Box
          gap="s16"
          style={{
            height: '100%',
          }}
        >
          <Box height="s24" />
          <Text.Normal weight="semibold" color="grey1000">
            {i18n.t('self_upsell.error_step.header')}
          </Text.Normal>
          <ErrorBox handleAssistance={handleAssistance} />
        </Box>
        <Box flexDirection="row" justifyContent="flexEnd" paddingTop="s24">
          <F0Button
            size="lg"
            variant="outline"
            label={i18n.t('self_upsell.common.close')}
            onClick={onClose}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default ErrorStep
